/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const AnchorButtonFragment = {
  AnchorButton: gql`
    fragment AnchorButtonQuery on anchorButton_Entry {
      buttonAlignment
      buttonArrowDirection
      buttonLabel
      buttonStyle
      ctaTag
      styles
      typeHandle
      scrollTo
    }
  `,
};
